import moment from "moment";
import React from "react";
import { endpoint } from "views/pages/manage/common/constant";
import { getCookie } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { isCentralizedAdmissionCase } from "views/pages/manage/unAssigned/studentCharges/studentChargesDetails/common";
import { isActiveBusinessArea } from "views/pages/manage/unAssigned/collectPayment/utils.jsx";

export const receiptBasicDetails = [
  { key: "acknowledgementId", label: "Acknowledgement ID" },
  { key: "receiptNumber", label: "PSERP ID" },
  { key: "receiptDate", label: "Created On" },
    { key: "createdBy", label: "Created By" },

];

export const studentDetails = [
  { key: "psid", label: "PSID" },
  { key: "studentName", label: "Student Name" },
  { key: "studentEmailId", label: "Email ID" },
  { key: "fatherName", label: "Father’s name" },
  { key: "phoneNumber", label: "Phone Number" },
  { key: "studentAddress", label: "Address" },
  { key: "city", label: "City" },
  { key: "state", label: "State" },
];

export const checkCHKLDDModificationEligibility = (payObj) => {
  if (["CHKL", "DD"]?.includes(payObj?.paymentMode)) {
    return payObj.paymentStatus == "NP" ? true : false;
  }
  return true;
};

export const courseDetails = [
  { key: "courseIds", label: "Course Id" },
  { key: "term", label: "Term" },
];
export const paymentModeMapping = {
  cash: "Cash",
  creditCard: "CC",
  online: "OP",
  cheque: "CHKL",
  adb: "ADB",
  eft: "EFT",
  jodo: "JODO",
  adj: "ADJ",
  cmp: "CMP",
  sdj: "SDJ",
  debitCard: "DB",
  dd: "DD",
  loanEDV: "EDV",
  loanPRP: "PRP",
  loanBFL: "BFL",
  qrc: "QRC",
  Link: "Link",
  jemi: "JEMI",
  gqc: "GQC",
  mpos:"MPOS",
  AXSB:"AXSB"
};
export const allowedChangePaymentModeMapping = {
  CHKL: ["EFT", "OP", "CC", "DB", "CASH", "DD", "MPOS", "CHKL", "AXSB"],
  MPOS: ["EFT", "OP", "CC", "DB", "CASH", "DD", "CHKL", "MPOS", "AXSB"],
  DD: ["EFT", "OP", "CC", "DB", "CASH", "CHKL", "MPOS", "DD", "AXSB"],
  EFT: ["CHKL", "OP", "CC", "DB", "CASH", "DD", "MPOS", "EFT", "AXSB"],
  OP: ["EFT", "MPOS", "CC", "DB", "CASH", "DD", "CHKL", "OP", "AXSB"],
  CC: ["EFT", "OP", "DD", "DB", "CASH", "CHKL", "MPOS", "CC", "AXSB"],
  DB: ["EFT", "OP", "CC", "CHKL", "CASH", "DD", "MPOS", "DB","AXSB"],
  AXSB: ["EFT", "OP", "DD", "DB", "CASH", "CHKL", "MPOS", "CC", "AXSB"],
};
export const nonEligiblePayModeChange = [
  "ADJ",
  "CMP",
  "SDJ",
  "JODO",
  "LINK",
  "ADB",
  "QRC",
  "BFL",
  "EDV",
  "GQC",
  "JEMI",
  "PRP",
  "BYJU",
  "CASH",
];
export const paymentCodeMapping = {
  Cash: "cash",
  CC: "creditCard",
  OP: "online",
  CHKL: "cheque",
  ADB: "adb",
  EFT: "eft",
  JODO: "jodo",
  ADJ: "adj",
  CMP: "cmp",
  SDJ: "sdj",
  DB: "debitCard",
  DD: "dd",
  EDV: "loanEDV",
  PRP: "loanPRP",
  BFL: "loanBFL",
  QRC: "qrc",
  Link: "Link",
  JEMI: "jemi",
  GQC: "gqc",
};
export const paymentMoodeHeading = {
  CASH: "Cash details",
  CHKL: "Cheque details",
  DD: "Demand draft details",
  CC: "Credit card details",
  DB: "Debit Card details",
  OP: "Online payment details",
  ADB: "Amount deposited in bank details",
  EFT: "Electronic Fund Transfer details",
  JODO: "JODO payment details",
  ADJ: "Adjustment payment details",
  CMP: "CMPR Paymode details",
  SDJ: "Discontinue Adjustment details",
  EDV: "Loan Bajaj Finserv Ltd details",
  PRP: "PRP details",
  BFL: "EDV details",
  QRC: "QR Code details",
  LINK: "Link details",
  Link: "Link details",
  JEMI: "JODO EMI details",
  GQC: "GQC details",
};
export const currentPaymentMoodeMapping = {
  CASH: "cash",
  CHKL: "cheque",
  DD: "dd",
  CC: "cc",
  DB: "db",
  OP: "online",
  ADB: "adb",
  EFT: "eft",
  JODO: "jodo",
  ADJ: "adj",
  CMP: "cmp",
  SDJ: "sdj",
  EDV: "loanEDV",
  PRP: "loanPRP",
  BFL: "loanBFL",
  QRC: "qrc",
  Link: "Link",
  JEMI: "jemi",
  GQC: "gqc",
};
export const EditIcon = ({ color = "#0F0F0F" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M11.7476 18.443H19.0002"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.78 1.79479C11.5557 0.867787 12.95 0.731856 13.8962 1.49173C13.9485 1.53296 15.6295 2.83879 15.6295 2.83879C16.669 3.46719 16.992 4.80311 16.3494 5.82259C16.3153 5.87718 6.81195 17.7645 6.81195 17.7645C6.49578 18.1589 6.01583 18.3918 5.50291 18.3973L1.86353 18.443L1.04353 14.9723C0.928662 14.4843 1.04353 13.9718 1.3597 13.5773L10.78 1.79479Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.021 4.00085L14.4732 8.18798"
        stroke={"color"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PrintIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6 18H4C3.46957 18 2.96086 17.7893 2.58579 17.4142C2.21071 17.0391 2 16.5304 2 16V11C2 10.4696 2.21071 9.96086 2.58579 9.58579C2.96086 9.21071 3.46957 9 4 9H20C20.5304 9 21.0391 9.21071 21.4142 9.58579C21.7893 9.96086 22 10.4696 22 11V16C22 16.5304 21.7893 17.0391 21.4142 17.4142C21.0391 17.7893 20.5304 18 20 18H18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 14H6V22H18V14Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 9V2H18V9"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const FeeIcon = ({ color }) => {
  return (
    <svg width="22" height="26" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="MoneyWavy">
        <path id="Vector"
          d="M19.0813 4.68754C18.9913 4.63138 18.8885 4.59905 18.7826 4.59358C18.6766 4.58811 18.5711 4.60969 18.4758 4.65629C15.1219 6.29691 12.7266 5.52816 10.1945 4.71722C7.53125 3.86957 4.78125 2.99066 0.975781 4.84847C0.870685 4.89979 0.782094 4.97956 0.720084 5.07872C0.658073 5.17788 0.62513 5.29246 0.625 5.40941V14.7789C0.624985 14.885 0.651952 14.9893 0.703363 15.082C0.754773 15.1748 0.828937 15.2529 0.918875 15.3091C1.00881 15.3653 1.11157 15.3977 1.21747 15.4032C1.32336 15.4087 1.42893 15.3872 1.52422 15.3407C4.87813 13.7 7.27344 14.4688 9.80937 15.2797C11.3125 15.7602 12.8438 16.25 14.575 16.25C15.9102 16.25 17.3664 15.9594 19.0211 15.1516C19.1262 15.1003 19.2148 15.0205 19.2768 14.9213C19.3388 14.8222 19.3717 14.7076 19.3719 14.5907V5.22113C19.3728 5.11481 19.3466 5.01001 19.2958 4.91664C19.2449 4.82327 19.1711 4.74441 19.0813 4.68754ZM3.75 11.875C3.75 12.0408 3.68415 12.1998 3.56694 12.317C3.44973 12.4342 3.29076 12.5 3.125 12.5C2.95924 12.5 2.80027 12.4342 2.68306 12.317C2.56585 12.1998 2.5 12.0408 2.5 11.875V6.87504C2.5 6.70928 2.56585 6.55031 2.68306 6.43309C2.80027 6.31588 2.95924 6.25004 3.125 6.25004C3.29076 6.25004 3.44973 6.31588 3.56694 6.43309C3.68415 6.55031 3.75 6.70928 3.75 6.87504V11.875ZM10 12.5C9.50555 12.5 9.0222 12.3534 8.61107 12.0787C8.19995 11.804 7.87952 11.4136 7.6903 10.9567C7.50108 10.4999 7.45157 9.99726 7.54804 9.51231C7.6445 9.02736 7.8826 8.5819 8.23223 8.23227C8.58186 7.88264 9.02732 7.64454 9.51227 7.54807C9.99723 7.45161 10.4999 7.50112 10.9567 7.69034C11.4135 7.87956 11.804 8.19999 12.0787 8.61111C12.3534 9.02223 12.5 9.50558 12.5 10C12.5 10.6631 12.2366 11.299 11.7678 11.7678C11.2989 12.2366 10.663 12.5 10 12.5ZM17.5 13.125C17.5 13.2908 17.4342 13.4498 17.3169 13.567C17.1997 13.6842 17.0408 13.75 16.875 13.75C16.7092 13.75 16.5503 13.6842 16.4331 13.567C16.3158 13.4498 16.25 13.2908 16.25 13.125V8.12504C16.25 7.95928 16.3158 7.80031 16.4331 7.68309C16.5503 7.56588 16.7092 7.50004 16.875 7.50004C17.0408 7.50004 17.1997 7.56588 17.3169 7.68309C17.4342 7.80031 17.5 7.95928 17.5 8.12504V13.125Z"
          fill={color} />
      </g>
    </svg>

  );
};
export const statusStyle = {
  Rejected: {
    backgroundColor: "#F9D9D7",
    color: "#B32306",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  "Auto-Rejected": {
    backgroundColor: "#F9D9D7",
    color: "#B32306",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  Approved: {
    backgroundColor: "#BBE2CE",
    color: "#0B442D",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  Success: {
    backgroundColor: "#BBE2CE",
    color: "#0B442D",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  Pending: {
    backgroundColor: "#FFEDC8",
    color: "#705010",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
};

export const statusMapping = {
  SUCCESS: "Success",
  PENDING: "Pending",
  REJECTED: "Rejected",
  APPROVED: "Approved",
  "AUTO-REJECTED": "Auto-Rejected",
};

export const headerValidation = (acknowledgementId, receiptId, setHeader) => {
  if (acknowledgementId && acknowledgementId.trim() && receiptId) {
    setHeader(acknowledgementId);
  } else if (receiptId && !(acknowledgementId && acknowledgementId.trim())) {
    setHeader(receiptId);
  } else if (!receiptId && acknowledgementId && acknowledgementId.trim()) {
    setHeader(acknowledgementId);
  }
};

export const receiptActionValidation = (
  res,
  setActionDisable = () => {},
  businessArea,
  opportunityOwnerId
) => {
  const forCentralizedAdmission = isCentralizedAdmissionCase(opportunityOwnerId);

  if (!res?.receiptNumber) {
    if (
      forCentralizedAdmission ||
      !isActiveBusinessArea({ buLabel: businessArea }) ||
      !moment(res?.receiptDate).isSame(moment(), "day")
    ) {
      {
        setActionDisable((prev) => ({
          ...prev,
          noActionEnable: true,
          modifyPayment: true,
        }));
      }
    }
    setActionDisable((prev) => ({ ...prev, noActionEnable: true }));
  } else if (
    forCentralizedAdmission ||
    !isActiveBusinessArea({ buLabel: businessArea }) ||
    !moment(res?.receiptDate).isSame(moment(), "day")
  ) {
    setActionDisable((prev) => ({ ...prev, modifyPayment: true }));
  }
};
export const getStatusDetail = (statusType, headingType, employeeId) => {
  if (statusType == "Rejected") {
    if (headingType == "heading") {
      return `Request is rejected by ${employeeId} `;
    }
  } else if (statusType == "Approved") {
    if (headingType == "heading") {
      return `Request is approved by ${employeeId} `;
    }
  } else if (statusType == "Pending") {
    if (headingType == "heading") {
      return `Request is pending`;
    }
  }
};

export const getBuIdByDisplayValue = async (displayValue) => {
  const data = await fetchAllPromisedData(
    endpoint.businessArea.getAllActiveV2,
    false
  );
  const bu = data.find((item) => item?.businessAreaDispValue == displayValue);
  return bu?.id;
};

export const getConditionalReferenceNumber = (referenceNumber, paymentMode) => {
  if (
    paymentMode == "BFL" ||
    paymentMode == "PRP" ||
    paymentMode == "EDV" ||
    paymentMode == "ADB"
  ) {
    return { label: referenceNumber, value: referenceNumber };
  }
  return referenceNumber;
};

export const getConditionalPaymentInfoCall = (paymentMode) => {
  if (["CMP", "SDJ", "ADJ", "CASH"].includes(paymentMode)) {
    return false;
  } else return true;
};
